import React from 'react';
import MatrixTableHead from './matrix-table-head';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { MatrixTableProps } from './matrix-table.types';

const MatrixTable: React.FC<MatrixTableProps> = ({
  tableHeadData,
  children,
  className,
  isVisible = true,
}) => {
  if (isVisible) {
    if (tableHeadData) {
      return (
        <div className={className} data-testid="matrix-table">
          <table>
            <MatrixTableHead thData={tableHeadData} />
            <tbody>{children}</tbody>
          </table>
        </div>
      );
    } else {
      console.warn(
        `MatrixTable received non valid tableHeadData: ${tableHeadData} - children: ${children}`
      );
      return null;
    }
  } else {
    return null;
  }
};

const StyledMatrixTable = styled(MatrixTable)`
  width: 100%;
  padding: 0.8rem 0;
  margin: 0;
  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid ${vars.borderGrey};
    padding: 0.4rem;
    ${vars.fontSize2}
    color: ${vars.black};
    text-align: right;
    vertical-align: top;
  }
  th {
    ${vars.fontSize1}
    font-weight: ${vars.fontWeightMedium};
    border: 1px solid ${vars.borderMidGrey};
    background-color: ${vars.borderGrey};
    text-align: right;
  }
  th:first-of-type {
    background-color: transparent;
    border-left-color: transparent;
    border-top-color: transparent;
  }
  .row-label {
    ${vars.fontSize1}
    font-weight: ${vars.fontWeightMedium};
    text-align: right;
    background-color: ${vars.greyHavens};
  }
  .sub-label {
    font-weight: ${vars.fontWeightRegular};
  }
`;

export default StyledMatrixTable;
